query team($teamId: ID!) {
  team(id: $teamId) {
    isCurrentAdmin
    id
    name
    groups(forCurrent: true) {
      id
      name
      icon { id name }
      color { id name }
      order_numerator
      order_denominator
      order
    }
    gradeLevels {
      id
      name
      icon { id name }
      color { id name }
    }
    studentCount
  }
}
